import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import PostcodeCheckContainer from '../components/postcodeCheck/PostcodeCheckContainer';
import DisclaimersSection, { IDisclaimersSectionProps } from './disclaimersSection/DisclaimersSection';
import PostcodeLabel from '../components/presentation/PostcodeLabel';

export interface IFooterProps {
  isDealerSelectionEnabled: boolean;
  disclaimerSectionId: string;
}

const Footer: FunctionComponent<IFooterProps> = ({ isDealerSelectionEnabled, disclaimerSectionId }) => {
  const intl = useIntl();
  const disclaimerTranslation: string = intl.formatMessage({
    id: 'spc.productCatalog.carPrice.disclaimer.primaryPrice',
  });
  const shouldRenderDisclaimerSection: boolean =
    disclaimerTranslation.length > 1 && disclaimerTranslation !== 'spc.productCatalog.carPrice.disclaimer.primaryPrice';
  const Component: FunctionComponent<IDisclaimersSectionProps> | FunctionComponent = shouldRenderDisclaimerSection
    ? DisclaimersSection
    : PostcodeLabel;

  if (isDealerSelectionEnabled) {
    return (
      <>
        <PostcodeCheckContainer />
        <Component disclaimerSectionId={disclaimerSectionId} />
      </>
    );
  }

  return null;
};

export default Footer;
